angular.module('aprima-utils').filter('apPhoneNumberFilter',
    ['PhoneNumberUtilities',
        function (PhoneNumberUtilities) {
            'use strict';

            return function (number){
                number = PhoneNumberUtilities.formatPhoneNumberString(number);
                return number;
            };
}]);
